<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4BFpe2/images/Cover.jpg?1696786074387" alt="This image is the cover for the book XINO #2, XINO"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">XINO #2, XINO
      </h1>
      <p class="bookDescription body article font2">
        <p>Meta-download #002 commence: Eisner-winning master cartoonist David Lapham (Stray Bullets) and co-writer Maria Lapham force our collective psyche into unrecognizable new dimensions in another thrilling installment of the mind-altering, sci-fi-bending anthology XINO! Award-winning and bestselling author Alex Segura (Secret Identity) and Zander Cannon (Kaijumax) embark on an intergalactic journey of revenge; up-and-coming creators Hagai Palevsky and illustrator Carson Thorn invert the work-life balance of corporate America; François Vigneault (Titan) and Artyom Trakhanov (First Knife) deliver bleeding-edge technology to Paleolithic man; and Alissa Sallah (Weeaboo) brings all-too-human nature to the barren landscape of Mars . . . Giddyup!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alissa M. Sallah, Zander Cannon, Alex Segura, Francois Vigneault
      </h2>
      
      <p class="authorDescription body article">Alissa Sallah is a cartoonist (and cosplayer) from small-town Ohio. She edits and contributes to the Bonfire Yearly Anthology (Stratos, Topia, Silk & Metal), has been featured in the Bitch Planet Triple Feature, the Yakuza 6 Song of Life artbook, and was the colorist on the Image comic series Sleepless. Her work can be found at alissasallah.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Oni Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ffcf8cd